import trans from '../../helpers/trans';
import { BaseErrorResponse } from '../@api/Sylius';
import { FetchResultClientError, FetchResultError, FetchResultSyliusError } from '../FetchResult/FetchResult';

export const transformBaseErrorResponseToString = (resource: BaseErrorResponse): string => {
    const title = resource['hydra:title'];
    const description = resource['hydra:description'];

    return `[${title}] ${description}`;
};

export const transformFetchResultErrorToString = (resource: FetchResultError): string => {
    const { title, detail } = resource;

    return `[${title}] ${detail}`;
};

export const transformFetchResultClientErrorToString = (resource: FetchResultClientError): string => {
    const { code, message } = resource;

    const isAuthenticationFailedResponse = (code === 401 && message === 'Ongeldige inloggegevens.');

    if (isAuthenticationFailedResponse) {
        return trans('entities.error.unknownEmailAddressOrPassword');
    }

    return `[${code}] ${message}`;
};

export const transformFetchResultSyliusErrorToString = (resource: FetchResultSyliusError): string => {
    const { type, message } = resource.error;

    return `[${type}] ${message}`;
};
